import React from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { ShoppingCart as CartIcon } from '@mui/icons-material';
import { NftGroup } from '../types';
import {
  cardSx,
  nameSx,
  kickerSx,
  subSx,
  cyanBtnSx,
  MONO,
  rarityHex,
  Pill,
  NftArt
} from './cardKit';
import { cardTitle } from '../../NFTCollection/components/CardInspectModal';

type Props = {
  group: NftGroup;
  cloudfrontBase?: string;
  formatRarity: (rarity: string | undefined | null) => string;
  getRarityColor?: (rarity: string | undefined | null) => string;
  onOpenGroup: (nftName: string) => void; // parent sets selectedNftGroup + viewMode
};

export const NftGroupCard: React.FC<Props> = ({
  group,
  cloudfrontBase,
  formatRarity,
  onOpenGroup
}) => {
  const nft = group.nft;

  const nftName = nft.name || 'Unknown Digital Collectible';
  const nftType = nft.type || 'Unknown';
  const nftRarity = nft.rarity || 'common';
  const nftFaction = nft.faction || 'Unknown';
  const rarityColor = rarityHex(nftRarity);

  const imgSrc = cloudfrontBase
    ? `${cloudfrontBase}/${nftType}/${nftName}/${nftRarity}.png`
    : '';

  return (
    <Card
      data-track="marketplace.open_group"
      data-track-nft={nftName}
      sx={{ ...cardSx, cursor: 'pointer' }}
      onClick={() => onOpenGroup(nftName)}
    >
      <NftArt
        imgSrc={imgSrc}
        alt={nftName}
        rarityColor={rarityColor}
        topLeft={
          <Pill color="#38e8ff" solid>
            {group.totalListings} available
          </Pill>
        }
        topRight={<Pill color={rarityColor}>{formatRarity(nftRarity)}</Pill>}
      />

      <CardContent
        sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', p: 2 }}
      >
        <Typography sx={nameSx}>{cardTitle(nftName)}</Typography>
        <Typography sx={kickerSx}>
          {nftType} · {nftFaction}
        </Typography>

        <Box sx={{ mt: 'auto', pt: 2 }}>
          <Typography sx={{ ...subSx, mb: 0.5 }}>Price range</Typography>
          <Box
            sx={{
              font: `900 20px ${MONO}`,
              color: '#ffcf40',
              fontVariantNumeric: 'tabular-nums',
              lineHeight: 1
            }}
          >
            {group.lowestPrice.priceInINC} – {group.highestPrice.priceInINC}
            <Box
              component="span"
              sx={{ ml: 0.5, font: `700 11px ${MONO}`, color: '#5c6b78' }}
            >
              INC
            </Box>
          </Box>
          <Typography sx={{ mt: 0.5, ...subSx }}>
            Avg {group.averagePrice.priceInINC} INC · ~$
            {group.lowestPrice.priceInUSD}–${group.highestPrice.priceInUSD}
          </Typography>

          <Button
            variant="contained"
            fullWidth
            disableElevation
            sx={{ ...cyanBtnSx, mt: 1.5 }}
            startIcon={<CartIcon />}
          >
            View all {group.totalListings} listings
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};
